export const state = () => ({
  playingTrack: null,
})

export const mutations = {
  setPlayingTrack(state, value) {
    state.playingTrack = value
  },
}
